module.exports = __webpack_public_path__ + "img/chart-bar.149beccc.svg";